import React from 'react';

import {
  Pressable,
  Text,
} from 'react-native';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

//import { useCmnz } from './_csCmn';
import { useLggz } from './_csLgg';
import { a } from './_csAbt';

import * as BoxC from './_ccbBoxC';

const _TextC = React.memo((pDz: ht.textCz) => {

//  const _sCz = useCmnz();
  const _sLggz = useLggz();

  const _abtType = pDz.abtType ?? 'nmlz';
  const _abtz = ica.textAbtz[_abtType] ? ica.textAbtz[_abtType]() : {};

//  if (pDz.bShow == false) return null;

  const _pfx = 
    pDz.textz?.pfx ?
      pDz.textz?.pfx
    : pDz.textz?.ept ?
//      _sCz.t(pDz.textz?.ept)
      _sLggz.t(pDz.textz?.ept)
//      pDz.textz?.ept
    : pDz.cz?.fldz?.pfx ?
      pDz.cz?.fldz?.pfx
    : pDz.cz?.fldz?.ept ?
//      _sCz.t(pDz.cz?.fldz?.ept)
      _sLggz.t(pDz.cz?.fldz?.ept)
//      pDz.cz?.fldz?.ept
    : _abtz.textz?.pfx ?
      _abtz.textz?.pfx
    : '';

  let _o = (
    cr.c(Text, {
      key: -10, 
      ... _abtz?.textz?.ptyz,
      ... pDz.textz?.ptyz,
      style: {
        ... _abtz.textz?.stlz,
        //... a(`dw/${pDz.cz?.fldz?.textW ?? 'ecp'}`),
        ... pDz.textz?.stlz,
      },
    },
      _pfx
    )
  );

  if (hf.f(pDz.boxStlz) || hf.f(_abtz.boxStlz)) { // Link への対応
    _o = (
      cr.c(BoxC.N, {
        key: 'Text.root',
        boxStlz: {
          ... _abtz.boxStlz,
          //... a(`dw/${pDz.cz?.fldz?.lblW ?? 'ecp'}`),
          ... pDz.boxStlz,
        },
        oClds: _o
      })
    );
  }

  if (hf.f(pDz.pslPtyz)) { // Link への対応
    _o = (
      cr.c(Pressable, {
        key: 'Psl.root',
        ...pDz.pslPtyz, // 改行されない場合、 stlz において dw/f を設定要
        style: {
          ... pDz.pslStlz,
        }
      }, 
        _o
      )
    );
  }

  return _o;

});

export const N = _TextC;

/*
export const H = (pDz: ht.textCz) => {
  return (
    cr.c(_TextC, {
      key: 'Hdg.root',
      ... pd,
      cz: {
        ... pd.cz,
        abtType: 'hdgz',
      }
    })
  )
};
*/